import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import Teams from "../../../../api/Teams";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import VarianceAnalysisWidget from "../../../finance/widgets/variance-analysis";

class TeamReportsSection3Step3 extends PureComponent {
  get left_content() {
    const team = Teams.currentTeam();
    const team_name = team ? team.name : "";
    const { expectedNetProfits, actualNetProfits } = this.props;

    return (
      <span>
        In this round, your CEO expected Team {team_name} to generate net
        profits of{" "}
        <AbbreviatedMillionNumberFormat
          value={expectedNetProfits}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />
        , but Team {team_name} actually generated net profits of{" "}
        <AbbreviatedMillionNumberFormat
          value={actualNetProfits}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />
        .<br />
        <br />
        Was your expectation too bullish or bearish? Please investigate if you
        didn't meet or exceed expectations.
        <br />
        <br />
        To learn more about FP&A, please view the following content
        <TypeformLink
          title="Financial Planning & Analysis"
          url={TypeformUrls.FINANCIAL_ANALYSIS}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    const { actual, expected, current_year } = this.props;

    return (
      <VarianceAnalysisWidget
        actual={actual}
        expected={expected}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Financial Planning and Analysis (FP&A) Page"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection3Step3;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-3/step-3.js